<script setup>
import img1 from '@/assets/app_client/MOCKUPWEB_310_firma.png'
</script>
<template>
  <img :src="img1" loading="lazy" />
</template>
<style lang="scss" scoped>
.image-wrapper {
  width: 100%;
  img {
    width: 100%;
  }
}
</style>
